import angular from "angular";
import { RecordGridViewController } from "./controller";

export const vsName = "recordGridView";

export const RecordGridViewComponentOptions: angular.IComponentOptions = {
  controller: RecordGridViewController,
  controllerAs: "recordGridViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridDataSource: "<",
    gridSettings: "<?",
    columns: "<",
    defaultSort: "<?",
    nameSingular: "<",
    namePlural: "<?",
    showAddButton: "<?",
    showAddButtonPermission: "<?",
  },
};
